import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

/** The school's time zone; the API stores and returns moments in UTC. */
export const SCHOOL_TIME_ZONE = "Asia/Tashkent";

const DATE_TIME_FORMAT = "DD.MM.YYYY HH:mm";

/** A UTC moment from the API shown in school time, for example "05.10.2026 18:12". */
export function formatSchoolDateTime(value: string): string {
  return dayjs(value).tz(SCHOOL_TIME_ZONE).format(DATE_TIME_FORMAT);
}
